<template>
  <div class="group-buy">
    <div class="list-box">
      <div class="item-box" v-for="(item,index) in comData.goods" :key="index" @click="jumpDetail(item)">
        <div class="item-box-left">
          <van-image width="118" height="126" radius="10" :src="item.headImg || item.headImgList[0].url" alt="" fit="cover" />
          <div class="tap" v-if="item.goodsTag">{{item.goodsTag}}</div>
          <div class="number">{{item.teamNumber}}人团</div>
        </div>
        <div class="item-box-right">
          <div class="top">
            <span class="label" v-if="item.goodsTag">{{item.goodsTag}}</span>
            <span class="label">{{item.teamNumber}}人团</span>
            <span class="name">{{item.goodsName}}</span>
          </div>
          <div class="middle">
            <img class="img-icon" src="https://img3.quanyou.com.cn/joy/group1/M00/19/81/rB4ChWNiFa6AVt01AAAFOZwhQgM548.png" />
            <span class="text">已有200人参与拼团</span>
          </div>
          <div class="bottom">
            <div class="bottom-left">
              <span class="top">价格</span> 
              <span class="line">￥{{item.oldPrice}}</span>
              <div class="bottom">
                <span>{{item.groupBuyTitle}}</span>
                <span class="number marginLeft" v-if="item.groupBuyPrice > 0">￥{{item.groupBuyPrice}}</span>
                <span class="number marginLeft" v-else> 免费</span>
              </div>
            </div>
            <div class="bottom-right">我要开团</div>
          </div>
        </div>
      </div>
      <img v-if="!comData.goods.length" src="https://img3.quanyou.com.cn/joy/group1/M00/19/B0/rB4ChWNmDW-AVm31AAFtbVoB9gc205.png" alt="" />
    </div>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins],
}
</script>

<style lang="stylus" scoped>
  .group-buy {
    margin: 10rpx  0;
    .list-box {
      padding: 0 12px;
      .item-box {
        display: flex;
        width: 100%;
        height: 152px;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px 0 rgba(214,94,22,0.53);
        border-radius: 10px;
        margin-top: 14px;
        padding: 13px 16px 13px 12px;
        box-sizing: border-box;
        .item-box-left {
          position: relative;
          width: 118px;
          height: 126px;
          border-radius: 10px;
          margin-right: 13px;
          .tap {
            position: absolute;
            top: 0;
            left: 0;
            width: 100px;
            height: 30px;
            background: url('https://img3.quanyou.com.cn/joy/group1/M00/19/82/rB4ChWNiHBOAcICnAAALdjIYxKE762.png');
            background-size: 100% 100%;
            font-size: 12px;
            color: #FFFFFF;
            text-align: center;
            padding-top: 3px;
            box-sizing: border-box;
          }
          .number {
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 3px 7px;
            background: linear-gradient(66deg, #ED2725 0%, #F78632 100%);
            border-radius: 0px 5px 0px 10px;
            color: #FFFFFF;
            font-size: 6px;
            font-weight: bold;

          }
        }
        .item-box-right {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 7px 0 5px 0;
          .top {
            padding-bottom: 5px;
            border-bottom: 1px solid rgba(181,181,181,0.14)
            .label {
              padding: 1px 2px;
              border: 1px solid #ED2725;
              border-radius: 2px;
              font-size: 8px;
              color: #ED2725;
              margin-right: 1px;
            }
            .name {
              margin-left: 2px;
              font-size: 14px;
              color: #3E3A39;
              font-weight: 400;
              line-height: 20px;
              position: relative;
              bottom: -2px;
            }
          }
          .middle {
            margin-top: 5px;
            .img-icon {
              width: 13px;
              height: 14px;
            }
            .text {
              font-size: 8px;
              color: #ED2725;
              font-weight: 400;
              margin-left: 2px;
              padding: 0 1px;
              background-image: linear-gradient(to right, #fde2e2,#FFFFFF)
            }
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .bottom-left {
              .top {
                font-size: 9px;
                color: #3E3A39;
                opacity: 0.43;
              }
              .line {
                text-decoration:line-through;
                margin-left: 4px;
              }
              .bottom {
                color: #ED2725;
                font-size: 10px;
                .number {
                  font-size: 16px;
                  color: #ED2725;
                  font-weight: bold;
                  line-height: 16px;
                }
                .marginLeft {
                  margin-left: 4px;
                }
              }
            }
            .bottom-right {
              width: 84px;
              height: 24px;
              background: linear-gradient(94deg, #F16026 0%, #ED2725 100%);
              box-shadow: 0px 2px 3px 0rpx rgba(214,94,22,0.31);
              border-radius: 12px;
              font-size: 15px;
              color: #fff;
              font-weight: bold;
              text-align: center;
              line-height: 24px;
            }
          }
        }
      }
    }
    img {
      width: 100%;
      height: 350px;
    }
  }
</style>